const KaseyaUsersMappings = () => import('@/views/account/integrations/kaseya/mappings/kaseya-users-mappings-view.vue');
const KaseyaCompaniesMappings = () => import('@/views/account/integrations/kaseya/mappings/kaseya-companies-mappings-view.vue');
const KaseyaActivitiesMappings = () => import('@/views/account/integrations/kaseya/mappings/kaseya-activities-mappings-view');
const KaseyaOpportunitiesStatusMappings = () => import('@/views/account/integrations/kaseya/mappings/kaseya-opportunities-status-mappings-view');

import store from '@/stores/index';

export default [
    {
        path: '/Integrations/Kaseya/Manage/Users/Mappings',
        name: 'KaseyaUsersMappings',
        component: KaseyaUsersMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/Kaseya/Manage/Users/Mappings',
        name: 'ClientKaseyaUsersMappings',
        component: KaseyaUsersMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        }
    },
    {
        path: '/Integrations/Kaseya/Manage/Companies/Mappings',
        name: 'KaseyaCompaniesMappings',
        component: KaseyaCompaniesMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/Kaseya/Manage/Companies/Mappings',
        name: 'ClientKaseyaCompaniesMappings',
        component: KaseyaCompaniesMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        }
    },
    {
        path: '/Integrations/Kaseya/Manage/Activities/Mappings',
        name: 'KaseyaActivitiesMappings',
        component: KaseyaActivitiesMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/Kaseya/Manage/Activities/Mappings',
        name: 'ClientKaseyaActivitiesMappings',
        component: KaseyaActivitiesMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        }
    },
    {
        path: '/Integrations/Kaseya/Manage/OpportunitiesStatus/Mappings',
        name: 'KaseyaOpportunitiesStatusMappings',
        component: KaseyaOpportunitiesStatusMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/Kaseya/Manage/OpportunitiesStatus/Mappings',
        name: 'ClientKaseyaOpportunitiesStatusMappings',
        component: KaseyaOpportunitiesStatusMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        }
    }
]